/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Cart } from './Cart';
import {
    CartFromJSON,
    CartFromJSONTyped,
    CartToJSON,
} from './Cart';
import type { UserMe } from './UserMe';
import {
    UserMeFromJSON,
    UserMeFromJSONTyped,
    UserMeToJSON,
} from './UserMe';

/**
 * 
 * @export
 * @interface GetUserSession200ResponseAllOfData
 */
export interface GetUserSession200ResponseAllOfData {
    /**
     * 
     * @type {UserMe}
     * @memberof GetUserSession200ResponseAllOfData
     */
    user: UserMe;
    /**
     * 
     * @type {Cart}
     * @memberof GetUserSession200ResponseAllOfData
     */
    cart?: Cart;
}

/**
 * Check if a given object implements the GetUserSession200ResponseAllOfData interface.
 */
export function instanceOfGetUserSession200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user" in value;

    return isInstance;
}

export function GetUserSession200ResponseAllOfDataFromJSON(json: any): GetUserSession200ResponseAllOfData {
    return GetUserSession200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetUserSession200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserSession200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': UserMeFromJSON(json['user']),
        'cart': !exists(json, 'cart') ? undefined : CartFromJSON(json['cart']),
    };
}

export function GetUserSession200ResponseAllOfDataToJSON(value?: GetUserSession200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': UserMeToJSON(value.user),
        'cart': CartToJSON(value.cart),
    };
}

